import axios from "./axios"

function index() {
    return axios().get("/payment-modes");
}

function find(id) {
    return axios().get("/payment-modes/" + id);
}

function createAccount(data) {
    return axios().post("/payment-modes", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function removeAccount({paymentMode, ledgerAccountId}) {
    return axios().delete("/payment-modes/" + paymentMode + "/accounts/" + ledgerAccountId);
}

export default {
    index,
    find,
    createAccount,
    removeAccount
}